import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const CategoryList = () => {
  const [categories, setCategories] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [updatedName, setUpdatedName] = useState('');
  const [updatedDescription, setUpdatedDescription] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const response = await axios.get('https://api.deveshmeditechindia.com/api/categories');
      setCategories(response.data.categories);
    } catch (error) {
      console.error(error);
      setError('Failed to fetch categories.');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this category?')) return;
    try {
      await axios.delete(`https://api.deveshmeditechindia.com/api/categories/${id}`);
      setCategories(categories.filter(category => category._id !== id));
    } catch (error) {
      console.error(error);
      setError('Failed to delete category.');
    }
  };

  const openEditModal = (category) => {
    setSelectedCategory(category);
    setUpdatedName(category.name);
    setUpdatedDescription(category.description || '');
    setError('');
    setShowModal(true);
  };

  const handleUpdate = async () => {
    if (!updatedName.trim()) {
      setError('Category name is required.');
      return;
    }
    try {
      await axios.put(
        `https://api.deveshmeditechindia.com/api/categories/${selectedCategory._id}`,
        { name: updatedName, description: updatedDescription }
      );
      setShowModal(false);
      fetchCategories();
    } catch (error) {
      console.error(error);
      setError(error.response?.data?.message || 'Failed to update category.');
    }
  };

  return (
    <div className="container mt-4">
      <h2>Categories</h2>
      <Link to="/add-category" className="btn btn-primary mb-3">Add Category</Link>
      {error && <div className="alert alert-danger">{error}</div>}
      {loading ? (
        <div className="text-center">Loading...</div>
      ) : Array.isArray(categories) ? (
        <ul className="list-group">
          {categories.map(category => (
            <li key={category._id} className="list-group-item d-flex justify-content-between align-items-center">
              <div>
                <strong>{category.name}</strong>
                {category.description && <p className="mb-0 text-muted">{category.description}</p>}
              </div>
              <div>
                <button
                  className="btn btn-warning btn-sm me-2"
                  onClick={() => openEditModal(category)}
                >
                  Edit
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(category._id)}
                >
                  Delete
                </button>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <div>No categories found.</div>
      )}

      {/* Edit Modal */}
      {showModal && selectedCategory && (
        <div
          className="modal show fade d-block"
          tabIndex="-1"
          style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Category</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                {error && <div className="alert alert-danger">{error}</div>}
                <div className="mb-3">
                  <label className="form-label">Category Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={updatedName}
                    onChange={(e) => {
                      setUpdatedName(e.target.value);
                      if (error && e.target.value.trim()) setError('');
                    }}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Description</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    value={updatedDescription}
                    onChange={(e) => setUpdatedDescription(e.target.value)}
                  ></textarea>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleUpdate}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryList;
